<div style="padding:0% 2%;">
    <div class="warning-msgs" *ngIf="supplierHold && !preventativeHold">
        <tsl-alert status="warning">Your organization's Banking Details on file require IMMEDIATE ACTION. The banking on
            file
            has a failed payment
            due to {{this.rejectionReason}}. Please have your organization's Primary Contact ({{this.primaryContact}})
            or
            Finance
            Lead
            ({{this.financeLeadContact}}) review the Banking Tab
            and make changes as needed to make successful payments to your organization</tsl-alert>

    </div>
    <div class="warning-msgs" *ngIf="preventativeHold">
        <tsl-alert status="warning" icon="info">
            <strong i18n="@@reviewinprogress" t="reviewinprogress">Review In Progress</strong>
            <p style="margin: 0;" i18n="@@preventativeinprogress" t="preventativeinprogress">
              Please note that your information on file is currently under review with Tesla. User access and applicable change functionality may be temporarily restricted until the review has been completed. Tesla will reach out if further information is needed.            </p>
          </tsl-alert>

    </div>
            <div class="warning-msgs" *ngIf="showPendingContractTaskBanner">
                <tsl-alert status="warning">Please complete the required documents via the Tesla Tasks, <span
                        style="cursor: pointer;color:blue; text-decoration:underline;"
                        (click)="navigateToTasks()">here</span></tsl-alert>
            </div>
</div>